import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// Application routing
const Infrastructure = Loadable(lazy(() => import('views/infrastructure/Infrastructure')));
const LocationsList = Loadable(lazy(() => import('views/locations/LocationsList')));
const InfrastructureManageEntity = Loadable(
  lazy(() => import('views/infrastructure/InfrastructureManageEntity'))
);
const LocationManagement = Loadable(lazy(() => import('views/locations/LocationManagement')));
const LocationDetails = Loadable(lazy(() => import('views/locations/LocationDetails')));
const ProdForecastDetails = Loadable(
  lazy(() => import('views/production-forecast/ProdForecastDetails'))
);
const ForecastsList = Loadable(lazy(() => import('views/forecasts/ForecastsList')));
const ForecastManagement = Loadable(lazy(() => import('views/forecasts/ForecastManagement')));
const SourcesList = Loadable(lazy(() => import('views/sources/SourcesList')));
const TurbinesList = Loadable(lazy(() => import('views/turbines/TurbinesList')));
const TurbinesManagement = Loadable(lazy(() => import('views/turbines/TurbinesManagement')));
const PeriodicShedulesManagement = Loadable(
  lazy(() => import('views/periodic-schedules/PeriodicShedulesManagement'))
);
const SourcesManagement = Loadable(lazy(() => import('views/sources/SourcesManagement')));
const Comparison = Loadable(lazy(() => import('views/forecast-comparison/Comparison')));

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <Infrastructure />
    },
    {
      path: '/infrastructure',
      element: <Navigate to="/" replace />
    },
    {
      path: '/infrastructure/manage_entity',
      element: <InfrastructureManageEntity />
    },
    {
      path: '/locations',
      element: <LocationsList />
    },
    {
      path: '/locations/management/create',
      element: <LocationManagement />
    },
    {
      path: '/locations/management/:id',
      element: <LocationManagement />
    },
    {
      path: '/locations/:id',
      element: <LocationDetails />
    },
    {
      path: '/locations/:id/production_forecasts/:id',
      element: <ProdForecastDetails />
    },
    {
      path: '/turbines',
      element: <TurbinesList />
    },
    {
      path: '/turbines/management/create',
      element: <TurbinesManagement />
    },
    {
      path: '/turbines/management/:id',
      element: <TurbinesManagement />
    },
    {
      path: '/forecasts',
      element: <ForecastsList />
    },
    {
      path: '/forecasts/management/create',
      element: <ForecastManagement />
    },
    {
      path: '/forecasts/management/:id',
      element: <ForecastManagement />
    },
    {
      path: '/sources',
      element: <SourcesList />
    },
    {
      path: '/sources/management/create',
      element: <SourcesManagement />
    },
    {
      path: '/sources/management/:id',
      element: <SourcesManagement />
    },
    {
      path: '/periodic_schedules/management/create',
      element: <PeriodicShedulesManagement />
    },
    {
      path: '/periodic_schedules/management/:id',
      element: <PeriodicShedulesManagement />
    },
    {
      path: '/comparison',
      element: <Comparison />
    }
  ]
};

export default MainRoutes;
